import {Injectable} from '@angular/core';

/**
 * Translations for all the tooltips
 */
@Injectable({
  providedIn: 'root'
})
export class TooltipTranslationService {
  public i18nMobile: any = $localize`:@@general.tooltip.mobile:Mobile`;
  public i18nCheckedIn: any = $localize`:@@general.tooltip.checkedIn:Checked in`;
  public i18nTelephone: any = $localize`:@@general.tooltip.telephone:Telephone`;
  public i18nEmail: any = $localize`:@@general.tooltip.email:Email`;
  public i18nCustomerNumber: any = $localize`:@@general.tooltip.customerNumber:Customer Number`;
  public i18nMembershipNumber: any = $localize`:@@general.tooltip.membershipNumber:Membership Number`;
  public i18nEdit: any = $localize`:@@general.tooltip.edit:Edit`;
  public i18nEmailAuthorization: any = $localize`:@@general.tooltip.emailAuthorization:Email & Authorization`;
  public i18nMarketingPermission: any = $localize`:@@general.tooltip.marketingPermission:Marketing Permission`;
  public i18nDelete: any = $localize`:@@general.tooltip.delete:Delete`;
  public i18nShowCustomer: any = $localize`:@@general.tooltip.showCustomer:Show customer`;
  public i18nDownloadImportFile: any = $localize`:@@general.tooltip.downloadImportFile:Download import file`;
  public i18nViewSepaMandates: any = $localize`:@@general.tooltip.viewSepaMandates:View SEPA mandates`;
  public i18nCreateNewReminder: any = $localize`:@@general.tooltip.createNewReminder:Create new reminder`;
  public i18nCreateNewContact: any = $localize`:@@general.tooltip.createNewContact:Create New Contact`;
  public i18nCreateNewMembership: any = $localize`:@@general.tooltip.createNewMembership:Create New Membership`;
  public i18nCreateNewUser: any = $localize`:@@general.tooltip.createNewUser:Create New User`;
  public i18nTicketing: any = $localize`:@@general.tooltip.ticketing:Ticketing`;
  public i18nCustomerLocked: any = $localize`:@@general.tooltip.customerLocked:Customer Locked`;
  public i18nCreateNewAddress: any = $localize`:@@general.tooltip.createNewAddress:Create New Address`;
  public i18nCreateNewBankData: any = $localize`:@@general.tooltip.createNewBankData:Create New Bank Data`;
  public i18nCreateNewFanStatus: any = $localize`:@@general.tooltip.createNewFanStatus:Create New Fan Status`;
  public i18nCreateNewPartnerSpecial: any = $localize`:@@general.tooltip.createNewPartnerSpecial:Create New Partner or Special`;
  public i18nCreateNewCustomer: any = $localize`:@@general.tooltip.createNewCustomer:Create New Customer`;
  public i18nAddNewAttribute: any = $localize`:@@general.tooltip.addNewAttribute:Add New Attribute`;
  public i18nPotentialDuplicates: any = $localize`:@@general.tooltip.potentialDuplicates:Potential duplicates`;
  public i18nOpenWebpage: any = $localize`:@@general.tooltip.openWebpage:Open webpage`;
  public i18nReset: any = $localize`:@@general.tooltip.reset:Reset`;
  public i18nPrioritize: any = $localize`:@@general.tooltip.prioritize:Prioritize`;
  public i18nDefer: any = $localize`:@@general.tooltip.defer:Defer`;
  public i18nDownloadCustomerList: any = $localize`:@@general.tooltip.downloadCustomerList:Download Customer List`;
  public i18nCustomerPoolSynced: any = $localize`:@@general.tooltip.customerPoolSynced:Customer pool is synced`;
  public i18nLockCustomer: any = $localize`:@@general.tooltip.lockCustomer:Lock customer`;
  public i18nUnlockCustomer: any = $localize`:@@general.tooltip.unlockCustomer:Unlock customer`;
  constructor() { }
}
